<template>
    <vx-popover hover arrow placement="top">
        <vx-badge size="xs" color="sky" data-test="sso-badge">
            <font-awesome-icon :icon="faRightToBracket" class="-mx-0.5" /> SSO
        </vx-badge>
        <template v-slot:content>Logs in with SSO</template>
    </vx-popover>
</template>

<script lang="ts" setup>
import { faRightToBracket } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxPopover } from '@voxie/frontend-components';
</script>
